/* eslint-disable */
import { apiHttpClient as httpClient } from 'core/services';
import type { SearchState } from 'core/types';
import type { UUID } from 'short-uuid';
import { uuid } from 'short-uuid';

import type { IRead, IWrite } from './interfaces';

export class RestAPIRepository implements IRead<any>, IWrite<any> {
  private url: string;

  protected instance: any;

  constructor(name: string) {
    this.url = `${name}/`;
    this.instance = httpClient;
  }

  request = async (path: string, payload: any, method = 'GET') => {
    const { data, status } = await this.instance.request({
      method,
      url: path,
      data: payload,
    });

    return { data, status };
  };

  get = async (_id: UUID): Promise<any> => {
    const { data } = await this.instance.get(`${this.url}${_id}`);

    return data;
  };

  getChildren = (_parent: UUID): Promise<Promise<any>[]> => {
    throw new Error('Method getChildren not implemented.');
  };

  getAll = async (): Promise<Promise<any>[]> => {
    const { data } = await this.instance.get(this.url);

    return data;
  };

  batch = async (_items: any[]): Promise<any> => {
    throw new Error('Method batch not implemented.');
  };

  create = async (item: any): Promise<any> =>
    this.instance.request(this.url, { _id: uuid(), ...item }, 'POST');

  update = async (item: any): Promise<any> => this.instance.request(this.url, item, 'PUT');

  remove = async (_id: string): Promise<any> => {
    throw new Error('Method remove not implemented.');
  };

  find = async (_root: UUID, _search: SearchState, _assignments: any[]): Promise<any> => {
    throw new Error('Remove find not implemented.');
  };
}
